(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-marketing/views/receivers.js') >= 0) return;  svs.modules.push('/modules/grassroots-marketing/views/receivers.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.grassroots_marketing=_svs.grassroots_marketing||{};
_svs.grassroots_marketing.templates=_svs.grassroots_marketing.templates||{};
svs.grassroots_marketing.templates.receivers = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"grassroots\">\n  <div class=\"receivers-app\" />\n</div>";
},"useData":true});
Handlebars.partials['svs-grassroots_marketing-receivers'] = svs.grassroots_marketing.templates.receivers;
})(svs, Handlebars);


 })(window);